import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Navigate } from '@ngxs/router-plugin';
import { Actions, Store } from '@ngxs/store';
import { ModuleCertificateExtended } from 'app/library/module-certificate/models/module-certificate.extended.model';
import { ModuleService } from 'app/library/module/services/module.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-manage-user-certificates-dialog',
    templateUrl: './manage-user-certificates-dialog.component.html',
    styleUrls: ['./manage-user-certificates-dialog.component.scss'],
})
export class ManageUserCertificatesDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    title: string;

    @Input()
    actionButtonText: string;

    @Input()
    moduleCertificates: ModuleCertificateExtended[];

    selectedCertificateIds: string[];
    currentModuleId: string;
    sendNotifications = true;
    isSaveButtonDisabled = true;

    constructor(
        public dialogRef: MatDialogRef<ManageUserCertificatesDialogComponent>,
        protected _matSnackBar: MatSnackBar,
        protected _store: Store,
        protected _action$: Actions,
        protected _translateService: TranslateService,
        private _moduleService: ModuleService
    ) {
        super();

        this.currentModuleId = this._moduleService.getCurrentModule().id;
    }

    ngOnInit(): void {
        this.moduleCertificates.forEach((moduleCertificate) => {
            moduleCertificate.isSelected = false;
        });
    }

    checkboxChangedValue(): void {
        for (let i = 0; i < this.moduleCertificates.length; i++) {
            if (this.moduleCertificates[i].isSelected) {
                this.isSaveButtonDisabled = false;
                return;
            }
            this.isSaveButtonDisabled = true;
        }
    }

    goToManageUserCertificates() {
        this.dialogRef.close();
        this._store.dispatch(new Navigate([`/modules/${this.currentModuleId}/edit/certificate-settings`]));
    }

    async saveChanges(): Promise<void> {
        const selectedModuleCertificateIds = this.moduleCertificates.filter((moduleCertificate) => moduleCertificate.isSelected).map((moduleCertificate) => moduleCertificate.id);
        this.dialogRef.close({ selectedModuleCertificateIds, sendNotifications: this.sendNotifications });
    }
}
